// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const druddigon: PokeData = {
  "id": 621,
  "name": "druddigon",
  "height": 16,
  "weight": 1390,
  "base_experience": 170,
  "types": [
    PokeType.DRAGON
  ],
  "api_moves": [
    "scratch",
    "leer",
    "bite",
    "dragon-rage",
    "slash",
    "scary-face",
    "outrage",
    "metal-claw",
    "crunch",
    "superpower",
    "revenge",
    "dragon-claw",
    "night-slash",
    "rock-climb",
    "iron-head",
    "hone-claws",
    "chip-away",
    "dragon-tail"
  ],
  "moves": [
    "scratch",
    "leer",
    "bite",
    "scary-face",
    "outrage",
    "metal-claw",
    "crunch",
    "superpower",
    "dragon-claw",
    "night-slash",
    "dragon-breath",
    "dragon-vortex",
    "inner-spirit"
  ],
  "evolution_chain": {
    "id": 315,
    "item": null,
    "species": [
      {
        "name": "druddigon",
        "order": 622,
        "types": [
          PokeType.DRAGON
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      }
    ]
  },
  "stats": {
    "resistance": 133,
    "speed": 76,
    "ability_power": 191
  },
  "stat_changes": [],
  "catch_rate": 45,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
